import { Injectable, Injector, EventEmitter } from '@angular/core';
import { ScreenSaverConfiguration } from '../models/screen-saver-configuration';
import { LoggerService } from '../../../services/logger/logger.service';
import { DateTimeHelper } from '../models/date-time-helper';
import { VuConnectionHttpService } from './vu-connection-http.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TouchTileService } from './touch-tile.service';
import { ScreenService } from './screen.service';


@Injectable()
export class ScreenSaverService {

  private _configuration: ScreenSaverConfiguration;

  private iStarted: boolean;
  public isMainPage: boolean;

  private oTimeoutTimer: any = null;
  private iScheduleTimer: any = null;
  private readonly iScheduleCheckTimeoutSec = 15;
  private iScheduleShow: boolean;
  private iIsShow: boolean;

  constructor(
    private loggingService: LoggerService,
    private vuConnectionHttpService: VuConnectionHttpService,
    private router: Router,
    public dialog: MatDialog,
    private touchTileService: TouchTileService,
    private screenService: ScreenService,
  ) {
  }

  public get configuration(): ScreenSaverConfiguration {
    return this._configuration;
  }

  public set configuration(value: ScreenSaverConfiguration) {
    const isEqualsConfig = JSON.stringify(this._configuration) === JSON.stringify(value);
    this._configuration = value;
    this._restart_timeout_timer();
    if (!isEqualsConfig) {
      this._restart_schedule_timer();
    }
  }

  start() {
    if (!this.iStarted) {
      this.iStarted = true;
      this.loggingService.info('Screen Saver Service - Start');
    }

    this._restart_timeout_timer();

    this._restart_schedule_timer();
  }

  stop() {
    if (this.iStarted) {
      this.iStarted = false;
      this._clear_timeout_timer();
      this._clear_schedule_timer();
      this._stopShow();
      this.loggingService.info('Screen Saver Service - Stop');
    }
  }

  private _restart_schedule_timer() {
    if (!this._configuration || this._configuration.timeTo <= 0 || this._configuration.timeFrom <= 0) {
      this.loggingService.info(`Screen Saver Service - Schedule disabled`);
      return;
    }

    const fromTime =
      `${DateTimeHelper.getHour(this._configuration.timeFrom)}:${('0' + DateTimeHelper.getMinutes(this._configuration.timeFrom)).slice(-2)}`;
    const toTime =
      `${DateTimeHelper.getHour(this._configuration.timeTo)}:${('0' + DateTimeHelper.getMinutes(this._configuration.timeTo)).slice(-2)}`;

    this.loggingService.info(
      `Screen Saver Service - Schedule started, Timeout: ${this.iScheduleCheckTimeoutSec} sec, from time: ${fromTime}, to time: ${toTime}`);

    this.iScheduleTimer = setInterval(() => {
      this._check_schedule();
    }, this.iScheduleCheckTimeoutSec * 1000);
  }

  private _clear_schedule_timer() {
    if (!this.iScheduleTimer) {
      return;
    }
    clearInterval(this.iScheduleTimer);
    this.iScheduleTimer = null;
  }

  private _restart_timeout_timer() {
    this._clear_timeout_timer();

    if (!this._configuration || this._configuration.timeout < 1) {
      this.loggingService.info(`Screen Saver Service - Timeout disabled`);
      return;
    }

    this.loggingService.info(`Screen Saver Service - Timeout restart, Timeout: ${this._configuration.timeout} sec`);

    this.oTimeoutTimer = setTimeout(() => {
      this._startShow();
      this.loggingService.info(`Screen Saver Service - Timeout show start`);
    }, this._configuration.timeout * 1000);
  }

  private _clear_timeout_timer() {
    if (!this.oTimeoutTimer) {
      return;
    }
    clearTimeout(this.oTimeoutTimer);
    this.oTimeoutTimer = null;
  }

  private _check_schedule() {
    if (this._schedule_is_time) {
      this._startShow();
      if (!this.iScheduleShow) {
        this.loggingService.info(`Screen Saver Service - Schedule show start`);
        this.iScheduleShow = true;
      }
    } else {
      if (this.iScheduleShow) {
        this.loggingService.info(`Screen Saver Service - Schedule show stop`);
        this.iScheduleShow = false;
      }
      if (!this._configuration || this._configuration.timeout < 1) {
        this.forceStopShow();
      }
    }
  }

  private get _schedule_is_time(): boolean {
    if (!this._configuration
      ||
      this._configuration.timeTo <= 0
      ||
      this._configuration.timeFrom <= 0
      ||
      this._configuration.timeFrom === this._configuration.timeTo) {
      return false;
    }

    const now = DateTimeHelper.now;
    const today = DateTimeHelper.getToday(now);

    const dateFrom = DateTimeHelper.createDate(today, this._configuration.timeFrom);
    const dateTo = DateTimeHelper.createDate(today, this._configuration.timeTo);

    if (this._configuration.timeFrom > this._configuration.timeTo) {
      return now <= dateTo || now >= dateFrom;
    } else {
      return now >= dateFrom && now <= dateTo;
    }
  }

  private _startShow(): boolean {
    if (!this.isMainPage) {
      return false;
    }

    if (this.iIsShow) {
      return false;
    }

    this.iIsShow = true;

    if (this.configuration.disableLntBoard) {
      this.touchTileService.switchLntBoard(false);
    }

    if (this.configuration.disableScreen) {
      this.screenService.switchScreen(false);
    }

    this.loggingService.info(`Screen Saver Service - Start show`);

    if (this._configuration) {
      this.loggingService.info(`Screen Saver Service - Start show, Mode: ${this._configuration.mode}`);
    }

    this.dialog.closeAll();
    this.router.navigateByUrl('/screen-saver');

    return true;
  }

  private _stopShow() {
    this.loggingService.info('Screen Saver Service - Stop show');

    if (this.iIsShow) {
      this.touchTileService.switchLntBoard(true);
      this.screenService.switchScreen(true);
    }

    this.iIsShow = false;
  }

  forceStopShow() {
    if (this.iIsShow) {
      // this.dispatcherService.onUserActivity();
      // this.dispatcherService.machineHardResetRoot();
      this.stop();
      this.router.navigateByUrl('');
    }
  }

  updateConfiguration() {
    if (this._configuration) {
      return;
    }

    this.vuConnectionHttpService.getScreenSaverConfiguration()
      .then(screenSaverConfiguration => {
        this.configuration = screenSaverConfiguration;
      });
  }

  get isShow(): boolean {
    return this.iIsShow;
  }


}

